import React from 'react'
import styles from '../VisionDissatisfaction/VisionDissatisfaction.module.css'

const VisionDissatisfaction = () => {
  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <img src='Images/Eyes-close-up.webp' alt='Close-up of man eye illustrating vision dissatisfaction' loading="lazy" decoding="async" />
      </div>
      <div className={styles.content}>
        <h1 className={styles.title}>Vision Dissatisfaction</h1>
        <h3 className={styles.subtitle}>The leading cause of dropout in
          presbyopic contact lens wearers.</h3>
        <p className={styles.description}><b> 50% of contact lens wearers discontinue use by age 50, </b>coinciding with the onset
of presbyopia. Many drop out due to dissatisfaction with visual aberrations, ghosting images, and a steep cognitive adaptation curve.*</p>
        {/* <p className={styles.linkDecription}>Pucker, A. D., & Tichenor, A. A. (2020). <span className={styles.italictext}>A review of contact lens dropout. </span> <span> Clinical Optometry, 12,
          85–94. Retrieved from</span> <a className={styles.linkcontaint} href='https://pmc.ncbi.nlm.nih.gov/articles/PMC7323801/' target='blank'>https://pmc.ncbi.nlm.nih.gov/articles/PMC7323801/</a>
          </p> */}
      </div>

    </div>
  )
}

export default VisionDissatisfaction
